var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.per_cur),function(v,k,i){return _c('v-chip',{key:"`per_cur-${k}`"},[_vm._v("\n      "+_vm._s(v)+" "+_vm._s(k)+" \n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }